import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getLang, getMenus, getTenant, getUserName, saveUser } from "store/userSlice";
import { useForm } from "react-hook-form";
import { toast } from "helpers/toast";
import ErrorAlert from "components/ui/ErrorAlert";
import { Button, Field, Input, NativeSelect } from "components/ui";
import { useTranslation } from "translation/useTranslation";

export default function ProfileSettings() {
  const dispatch = useDispatch();

  const { translate, editableTranslate } = useTranslation();

  const lang = useSelector(getLang);

  const userName = useSelector(getUserName);
  const tenant = useSelector(getTenant);
  const menus = useSelector(getMenus);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, reset } = useForm();

  useEffect(() => {
    reset({ preferred_lang: lang });
  }, [lang]);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      setError(null);
      await dispatch(saveUser(data)).unwrap();
      setLoading(false);
      toast.success(translate('form.success.saved'));
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col d-flex">
        <div className={`bg-white w-100 p-4 content-card min-height-after-navbar`}>
          {
            !menus && <div className="mb-4">
              <div className="alert alert-warning" data-testid="no-permission-warning">
                {editableTranslate('login_users.no_permission')}
              </div>
            </div>
          }

          <h4>{editableTranslate('global.profile_settings', 'Profileinstellungen')}</h4>

          <div className="row mt-4">
            <div className="col-lg-3">
              {
                error && <ErrorAlert error={error} onClose={() => setError(null)} />
              }

              <form onSubmit={handleSubmit(onSubmit)} data-testid="profile-form">
                <div className="form-group">
                  <Field label={editableTranslate('global.account_id', 'Konto-ID')}>
                    <Input type="text" value={tenant} readOnly data-testid="account-id-input" />
                  </Field>
                </div>

                <div className="form-group">
                  <Field label={editableTranslate('global.username', 'Name der softwarenutzenden Person')}>
                    <Input type="text" value={userName} readOnly data-testid="username-input" />
                  </Field>
                </div>

                <div className="form-group">
                  <Field label={editableTranslate('global.preferred_lang', 'Sprachauswahl')}>
                    <NativeSelect data-testid="preferred-lang-select" {...register('preferred_lang')}>
                      <option value="de">German</option>
                      <option value="en">English</option>
                    </NativeSelect>
                  </Field>
                </div>
                <div>
                  <Button type="submit" variant="primary" loading={loading} data-testid="save-button">
                    {editableTranslate('button.save')}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
